import "../style/home/Home.css";
import HFeatures from "./H_ Features";
import HAds from "./H_Ads";
import HAmazingSuggest from "./H_AmazingSuggest";
import HBanner from "./H_Banner";
import HDownloadApp from "./H_DownloadApp";
import HFooter from "./H_Footer";
import HNav from "./H_Nav";
import HNewProduct from "./H_NewProduct";
import HSearch from "./H_Serach";

const Home = () => {
  return (
    <div className="Home">
      <HNav />
      <HBanner />
      <HSearch />
      <HAmazingSuggest />
      <HNewProduct />
      <HFeatures />
      <HAds />
      <HDownloadApp />
      <HFooter />
    </div>
  );
};

export default Home;
